'use es6';

import { INITIALIZE_CONFIG } from 'pricing-pages-unified-ui/constants/ActionTypes';

const config = (state = {}, action) => {
  switch (action.type) {
    case INITIALIZE_CONFIG:
      return action.config;

    default:
      return state;
  }
};

export default config;